import { TableCell, styled } from '@mui/material';
import React from 'react';

const TableHeaderCell = ({color = null, ...params }) => {

    const HeaderObj = styled(TableCell)(({theme}) => ({

        root: {

            backgroundColor: color ?? theme.palette.primary.main,

        }

    }));

    return <HeaderObj {...params}/>;

}



export default TableHeaderCell;